import { render, staticRenderFns } from "./section-team-node.vue?vue&type=template&id=1d4269d1&"
import script from "./section-team-node.vue?vue&type=script&lang=js&"
export * from "./section-team-node.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports